// Account Payable Payments States

export default {
  paymentList: [],
  paymentInfo: {}
}
